import type { ReactNode } from 'react';
import { useLocation } from 'react-router';

import { ErrorBoundary } from './ErrorBoundary';
import { ErrorFallback } from './ErrorFallback';

/** Error boundary inside `<main>`, so a broken page doesn't take the sidebar down with it. */
export const ContentErrorBoundary = ({ children }: { children: ReactNode }) => {
  const { pathname } = useLocation();

  return (
    <ErrorBoundary
      name="content"
      resetKey={pathname}
      fallback={({ onRetry }) => (
        <ErrorFallback
          title="Something went wrong"
          description="This screen ran into an unexpected problem. You can try again, or use the menu to go somewhere else."
          primaryAction={{ label: 'Try again', onClick: onRetry }}
        />
      )}
    >
      {children}
    </ErrorBoundary>
  );
};
